import { render } from "./CourseCard.vue?vue&type=template&id=0df536ef&scoped=true&ts=true"
import script from "./CourseCard.vue?vue&type=script&lang=ts"
export * from "./CourseCard.vue?vue&type=script&lang=ts"

import "./CourseCard.vue?vue&type=style&index=0&id=0df536ef&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0df536ef"]])

export default __exports__